<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <BomForwardDetailDeploy v-if='selectedIndex === 0'/>
    <BomReverseDeploy v-if='selectedIndex === 1'/>
    <BomForwardDeployCarOptionType v-if='selectedIndex === 2'/>
    <BomForwardDeployCustomer v-if='selectedIndex === 3'/>
    <!-- <BomForwardDetailDeploy v-if='selectedIndex === 4'/> -->
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
// import BomForwardDeploy from './BomForwardDeploy' bom완제품 정전게 -> bom 품목상세로 탭변경
import BomForwardDetailDeploy from './BomForwardDetailDeploy'
import BomReverseDeploy from './BomReverseDeploy'
import BomForwardDeployCarOptionType from './BomForwardDeployCarOptionType'
import BomForwardDeployCustomer from './BomForwardDeployCustomer'

export default {
  name: 'BomTreeDeployTab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: []
    }
  },
  components: {
    DxTabPanel,
    // BomForwardDeploy,
    BomForwardDeployCarOptionType,
    BomReverseDeploy,
    BomForwardDeployCustomer,
    BomForwardDetailDeploy
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        let temp = {}
        temp.title = tabNameArray[i]
        this.tabs.push(temp)
      }
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
